const LOGOUT_URL = "https://login.xueersi.com/newLogin/logout/?redirect_url=";
const LOGIN_URL = "https://login.xueersi.com/?redirect_url="; // 网校登录页面

export const fnDoShowLoginInThisPage = () => {
  // 未登录的，构建redirectUrl跳转网校登录
  const cburl = location.href;
  const redirectUrl = encodeURIComponent(cburl);
  const loginUrl = encodeURIComponent(
    `${LOGIN_URL}${encodeURIComponent(redirectUrl)}`
  );
  // 未登录的先登出，再登录
  const LOGINOUT = `${LOGOUT_URL}${encodeURIComponent(loginUrl)}`;
  location.replace(LOGINOUT);
};
